/*
 * @Author: 陈朝晖
 * @Date: 2023-10-13 14:10:53
 * @LastEditTime: 2023-10-13 14:13:48
 * @Description:
 */

import './assets/iconfont/iconfont.css';
export default function () {
    window.judgeDazeCollector = function (data, method = '$dazeCollector.push') {
        try {
            const attr = method.split('.');
            let thisObj;
            const fn = attr.reduce((prev, current) => {
                thisObj = prev;
                return prev && prev[current];
            }, window); // fn 里面的 this 指向 window，所以下面要改 this 指向
            if (typeof fn === 'function') {
                fn.call(thisObj, data);
            }
        } catch {
            // do nothing
        }
    };
}
